import { BaseThunkExtra } from 'shared'
import { configuredHub, configuredApi } from '../app/aws-exports'
import { Toast } from '../components/toast/toast'
import AnalyticsManager from '../services/AnalyticsManager'

export type PortalAppThunkExtraType = BaseThunkExtra

export const portalAppThunkExtra: PortalAppThunkExtraType = {
  API: configuredApi,
  Hub: configuredHub,
  AnalyticsManager: AnalyticsManager,
  Toast: Toast,
  // @TODO: This
  handleSupport: () => {},
  Keychain: {
    setGenericPassword: async () => ({ service: '', storage: '' }),
    getGenericPassword: async () => false,
    getAllGenericPasswordServices: async () => [],
    resetGenericPassword: async () => true,
    hasInternetCredentials: async () => false,
    setInternetCredentials: async () => ({ service: '', storage: '' }),
    requestSharedWebCredentials: async () => false,
    setSharedWebCredentials: async () => {},
  },
}
